import { QUOTE_TOS_LC_KEY, QUOTE_TOS_VERSION } from '.'
import { Approval, GetApproval, GetIsApproved } from './types'

export const getIsApproved: GetIsApproved = (approval) => {
  return approval.version === QUOTE_TOS_VERSION && approval.isApproved
}

export const getApproval: GetApproval = () => {
  try {
    return JSON.parse(window.localStorage.getItem(QUOTE_TOS_LC_KEY) ?? '') as Approval
  } catch {
    return {
      isApproved: false,
      version: QUOTE_TOS_VERSION
    }
  }
}

export const setApproval: VoidFunction = () => {
  window.localStorage.setItem(
    QUOTE_TOS_LC_KEY,
    JSON.stringify({
      isApproved: true,
      version: QUOTE_TOS_VERSION
    })
  )
}
